import { ValidationResult } from '@aurelia/validation';

import {
  ValidationEvent,
  ValidationResultsSubscriber,
  ValidationResultTarget,
} from '@aurelia/validation-html';

export class FieldValidationRenderer implements ValidationResultsSubscriber {
    public handleValidationEvent(event: ValidationEvent): void {
        for (const [target, results] of this.reverseMap(event.removedResults)) {
          this.remove(target, results);
        }
    
        for (const [target, results] of this.reverseMap(event.addedResults)) {
          this.add(target, results);
        }
    }

    public add(target: Element, results: ValidationResult[]): void {
        for (const result of results) {
            if (!result.valid) {
                target.classList.add('error');

                console.debug(`Add validation classes. Target: ${target} results: ${results}`);

                // suppress empty validation messages
                if (result.message !== '' ) {                
                    const message = document.createElement('span');
                    
                    message.className = 'validation-message-container';
                    message.textContent = result.message.toLowerCase();
                    message.id = `validation-message-${result.id}`;
                    target.parentNode.insertBefore(message, target.nextSibling);
                } 
            }
        }
    }

    public remove(target: Element, results: ValidationResult[]): void {      
        target.classList.remove('error');

        for (const result of results) {
            const message = document.getElementById(`validation-message-${result.id}`);

            if (message) {
                target.parentElement.removeChild(message);
            }
        }        
    }

    private reverseMap(results: ValidationResultTarget[]) {
        const map = new Map<Element, ValidationResult[]>();
        for (const { result, targets } of results) {
          for (const target of targets) {
            let targetResults = map.get(target);
            if (targetResults === void 0) {
              map.set(target, (targetResults = []));
            }
            targetResults.push(result);
          }
        }
        return map;
      }
}
